fetch(`https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=${Shopify.shop}&resource=default`).then((response) => {
    response.json().then((media) => {
        
        // console.log(media);
        // var i = media.length - 1;
      $.each(media.reverse(), function(index, m){

          if(m.media_type == "VIDEO")
          $(".insta-carousel").prepend("<div class='item swiper-slide'><a target='_blank' href='"+ m.permalink +"'><img class='swiper-lazy' data-src='"+m.thumbnail_url+"' alt=''></a></div>");
          else
          $(".insta-carousel").prepend("<div class='item swiper-slide'><a target='_blank' href='"+ m.permalink +"'><img class='swiper-lazy' data-src='"+m.media_url+"' alt=''></a></div>");
      });
    //   $('.insta-carousel').owlCarousel({
    //     items: 25,
    //     margin: 10,
    //     touchDrag: true,
    //     autoWidth:true,
    //     autoHeight: true
    // });
    var swiper = new Swiper('.swiper-insta-container', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        mousewheel:{
          forceToAxis: true,
      },
            lazy: {
          loadonTransitionStart: true,
          loadPrevNext: true,
      },
      preloadImages: false,

      watchSlidesVisibility: true,
      
      //   initialSlide: 1,
        grabCursor: true
      });
    });
});